/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qc_Fix_Max_LinesInputs */



/**
* | output |
* | --- |
* | "Too many lines" |
*
* @param {Qc_Fix_Max_LinesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const qc_fix_max_lines = /** @type {((inputs?: Qc_Fix_Max_LinesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qc_Fix_Max_LinesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Trop de lignes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zu viele Zeilen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Troppe righe")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Слишком много строк")
	if (locale === "es") return /** @type {LocalizedString} */ ("Demasiadas líneas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("行数过多")
	if (locale === "ja") return /** @type {LocalizedString} */ ("行数が多すぎます")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बहुत अधिक पंक्तियाँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Demasiadas linhas")
	return /** @type {LocalizedString} */ ("Too many lines")
});